// Exportando rotas para serem usadas pelo cliente e pelo servidor.

const SERVER_NODE = 'http://' + location.hostname + ':8089/banking-api'

const EXPORT_TREEGRID = SERVER_NODE + '/treegrid/exportTreeGrid'

module.exports = {
  EXPORT_TREEGRID
}



// WEBPACK FOOTER //
// ./build/jsonToExcel/exportRoutes.js